import React from 'react'
import imgHoja from '../../../assets/images/hoja_1.svg'
import imgHoja2 from '../../../assets/images/hoja_2.svg'
import './generic-modal.scss'

const GenericModal = ({ children, closeModal, customClass = '' }) => {
  return (
    <div className={`f-o-generic-modal ${customClass}`}>
      <div className='f-o-generic-modal__wrap'>
        <img
          className='f-o-generic-modal__img1'
          src={imgHoja}
          alt='hoja 1'
          loading='lazy'
        />
        <img
          className='f-o-generic-modal__img2'
          src={imgHoja2}
          alt='hola 2'
          loading='lazy'
        />
        <div className='f-o-generic-modal__wrap-content'>
          <div className='f-o-generic-modal__close' onClick={closeModal}>
            X
          </div>
          <div className='f-o-generic-modal__info'>{children}</div>
        </div>
      </div>
    </div>
  )
}

export default GenericModal
